module.exports = __webpack_public_path__ + "img/emoji_57.f2f5327d.png";